/**
 * A broken tournament-hand link, as the API reports it: `500 { code: "HANDS_UNAVAILABLE" }`
 * (spec 030 — see specs/030-dblink-local-host/contracts/hands-unavailable-error.md).
 *
 * This is the one test the learner surfaces use to show their retryable "could not be loaded" state,
 * and the one the API client's interceptor uses to hand this 500 back to the page instead of
 * redirecting to the error page. A genuinely empty pool is NOT this — it keeps its own response.
 */
export const HANDS_UNAVAILABLE = 'HANDS_UNAVAILABLE';

export function isHandsUnavailable(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const response = (error as { response?: { status?: number; data?: unknown } }).response;
  if (!response || response.status !== 500) return false;
  const data = response.data;
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { code?: unknown }).code === HANDS_UNAVAILABLE
  );
}
